<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [infos]="question.infos"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [display]="question.display"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>
<ng-container [formGroup]="formGroup">
  <ion-item>
    <ion-input
      *ngIf="question.type !== 'number' && question.type !== 'decimal'"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      [id]="question.key"
      [type]="question.type"
      [min]="question.min"
      [max]="question.max"
      (ionFocus)="onFocus()"
      (ionInput)="onInput()"
      (ionBlur)="onBlur()"
      [pattern]="question.pattern"
      [placeholder]="question.placeholder | translate"
      (ionChange)="onChange()"
    >
    </ion-input>

    <!-- input mode and pattern required on ios to force numeric keyboard
    Number type accepts [., -, e] from keyboard so combining decimal type and pattern [0-9]*
    for restricting user to insert [., -, e], and allow digits only to insert else display error -->
    <ion-input
      *ngIf="question.type === 'number'"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      [id]="question.key"
      [type]="'decimal'"
      (ionFocus)="onFocus()"
      (ionInput)="onInput()"
      (ionBlur)="onBlur()"
      inputmode="numeric"
      pattern="[0-9]*"
      [placeholder]="question.placeholder | translate"
      (ionChange)="onChange()"
    >
    </ion-input>

    <ion-input
      *ngIf="question.type === 'decimal'"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      [id]="question.key"
      [type]="question.type"
      (ionFocus)="onFocus()"
      (ionInput)="onInput()"
      (ionBlur)="onBlur()"
      inputmode="decimal"
      pattern="([0-9])+([.|,]([0-9])+)?"
      [placeholder]="'TEXT.DECIMAL_PLACEHOLDER' | translate"
      (ionChange)="onChange()"
    >
    </ion-input>
    <div
      class="unit"
      [class.bp-rtl]="document.dir === 'rtl'"
      [ngStyle]="{
        background: color,
        color: contrast,
        width: 'auto',
        paddingRight: '2%',
        paddingLeft: '2%'
      }"
      *ngIf="question.unit"
    >
      {{ question.unit }}
    </div>
  </ion-item>
</ng-container>
